import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { default as Logo } from 'src/assets/images/logos/miliboo-dp-min.svg?react';

export function SplashScreen(): ReactElement {
  const { t } = useTranslation();

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-layout'>
      <div className='flex flex-col items-center space-y-6'>
        <div className='relative'>
          <div className='bg-primary-default/20 absolute inset-0 animate-ping rounded-full'></div>
          <div className='relative'>
            <Logo className='h-16 w-16 text-primary-default' />
          </div>
        </div>
        <div className='text-center'>
          <h1 className='text-2xl font-bold text-layout-foreground'>
            {t('Demand planning')}
          </h1>
          <p className='mt-1 text-sm text-layout-foreground-secondary'>
            {t('Loading')}
          </p>
        </div>
        <div className='flex space-x-1'>
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary-default [animation-delay:-0.3s]'></div>
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary-default [animation-delay:-0.15s]'></div>
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary-default'></div>
        </div>
      </div>
    </div>
  );
}
